export { default } from './TimelineOppositeContent';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TimelineOppositeContent/index.js
// module id = 387
// module chunks = 0